var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollarBlock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-32.3%",
    y: "-23.1%",
    width: "164.6%",
    height: "164.6%",
    filterUnits: "objectBoundingBox",
    id: "ga9hjlmopa"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.349019608 0 0 0 0 0.431372549 0 0 0 0 0.952941176 0 0 0 0.195804196 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "gqpwsxyc9b",
    x: 0,
    y: 0,
    width: 65,
    height: 65,
    rx: 8
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(12 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ga9hjlmopa)",
    xlinkHref: "#gqpwsxyc9b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#gqpwsxyc9b"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.818 18.803h41.364v41.364H23.818z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.947 22.25a13.788 13.788 0 0 1 5.674 26.357 13.788 13.788 0 1 1-18.245-18.245 13.793 13.793 0 0 1 12.571-8.112zm-6.894 10.34a10.34 10.34 0 1 0 0 20.683c5.711 0 10.34-4.63 10.34-10.341 0-5.711-4.629-10.341-10.34-10.341zm1.724 1.724v1.724h3.446v3.447H39.33a.862.862 0 0 0-.156 1.71l.156.013h3.447a4.309 4.309 0 0 1 0 8.618v1.723H39.33v-1.723h-3.447v-3.447h6.894a.862.862 0 0 0 .155-1.71l-.155-.014H39.33a4.309 4.309 0 1 1 0-8.617v-1.724h3.447zm5.17-8.617a10.315 10.315 0 0 0-7.728 3.47 13.788 13.788 0 0 1 14.598 14.599 10.34 10.34 0 0 0-6.87-18.069z",
    fill: "#576CF3",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarBlock);
export default __webpack_public_path__ + "static/media/dollar-block.f1236eecd3e947a6b444183c767e9b82.svg";
export { ForwardRef as ReactComponent };